var audio_rtlignore_default = {
  "fontElementMap": "yOpgf",
  "container": "AZ9ZU",
  "customPlayer": "XdplT",
  "slim": "sM1qJ",
  "playPauseButton": "GVVHF",
  "coverImage": "BkNFH",
  "trackDetailsContainer": "i4tWw",
  "controlsContainer": "_5-PvE",
  "controlsGroup": "vajcq",
  "sliderContainer": "X8-dm",
  "audioDuration": "AkBRg",
  "isLoading": "eCZDQ",
  "audioDetails": "U7enb",
  "authorName": "-SqL2",
  "title": "WQv18",
  "dropdownMenuWrapper": "tBqtV",
  "dropdownSelectedButton": "IEy7x",
  "dropdownContent": "RW7QX",
  "dropdownContentWithIcon": "wVE9w",
  "audioLoader": "lMXW6"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
